<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">我的粉丝</div>
          <div class="money">
            <span class="num">{{ fans_count }}</span> 人
          </div>
        </div>
        <div class="iconfont icon-yonghu"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="header th">
          <div class="td ">头像</div>
          <div class="td uf1 name">名称</div>
          <div class="td">关联</div>
        </div>
        <div class="item th parent">
          <div class="td">
            <img class="logo" v-if="parent.avatar" :src="parent.avatar" />
            <img class="logo" v-else src="@assets/images/writeOff.jpg" />
          </div>
          <div class="name uf1">
            {{ parent.name || parent.nick_name || "无客户经理" }}
            <span class="copy copy-data" :data-clipboard-text="parent.nick_name"
              >复制</span
            >
            <!--<div class="time">-->
            <!--<span class="phone">{{ parent.mobile }}</span>-->
            <!--<a-->
            <!--v-if="parent.mobile"-->
            <!--class="iconfont icon-tonghua font-color-red"-->
            <!--:href="'tel:' + parent.mobile"-->
            <!--&gt;</a>-->
            <!--</div>-->
          </div>
          <div class="fuji">
            专属客户经理
          </div>
        </div>
        <div
          class="item th"
          v-for="(item, index) in info"
          :key="index"
          @click="subOrder(item)"
        >
          <div class="td">
            <img class="logo" v-if="item.avatar" :src="item.avatar" />
            <img class="logo" v-else src="@assets/images/writeOff.jpg" />
          </div>
          <div class="name uf1">
            {{ item.name || item.nick_name }}
            <span
              class="copy copy-data"
              @click.prevent.stop=""
              :data-clipboard-text="item.nick_name"
              >复制</span
            >
            <div class="time">
              时间：{{ item.add_time ? item.add_time : "暂无" }}
            </div>
          </div>
          <div :class="[item.parent_id == uid ? 'yiji' : 'erji']">
            {{ item.parent_id == uid ? "一级" : "二级" }}
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
.list .th {
  padding: 0 0.25rem;
}
.list .parent {
  border-bottom: 1px solid #cccccc;
  padding-bottom: 0.3rem;
}
.list .header {
  background: #cccccc;
  padding: 0.25rem;
}
.uf1 {
  flex-grow: 1;
}
.yiji {
  color: #1abb1d;
}
.erji {
  color: red;
}
.fuji {
  color: #2a7efb;
  font-weight: bold;
}
.th {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list .td {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: content-box;
}

.list .name {
  padding-left: 0.25rem;
}
.logo {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 100%;
  margin-right: 0.1rem;
}
.list .time {
  color: #999999;
  margin-top: 0.15rem;
  font-size: 0.25rem;
}
.list .item.th {
  margin: 0.25rem 0;
}
.list .item .me {
  color: red;
}
.copy {
  font-size: 0.2rem;
  color: #333;
  border-radius: 0.03rem;
  border: 1px solid #666;
  padding: 0.04rem 0.15rem;
  margin-left: 0.24rem;
}
</style>
<script>
import { fansList, fansCount, myParent } from "@/api/user";
import Loading from "@components/Loading";
import ClipboardJS from "clipboard";

export default {
  name: "Fans",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      parent: {},
      fans_count: 0,
      where: {
        page: 1,
        page_size: 20
      },
      types: 3,
      loaded: false,
      loading: false,
      uid: 0
    };
  },
  mounted: function() {
    this.uid = this.$store.state.app.userInfo.id || 0;
    this.fansCount();
    this.myParent();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    subOrder(item) {
      if (item.parent_id != this.uid) return;
      this.$router.push("/user/promoter_order/" + item.id);
    },
    myParent() {
      let pid = this.$store.state.app.userInfo.parent_id;
      if (!pid || pid == 71) {
        return;
      }
      myParent()
        .then(r => {
          this.parent = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      fansList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = !res.data || res.data.length < that.where.page_size;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
          this.$nextTick(function() {
            var copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", e => {
              e.preventDefault();
              this.$dialog.success("复制成功");
            });
            clipboard.on("error", e => {
              e.preventDefault();
              alert("复制失败");
            });
          });
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    fansCount: function() {
      let that = this;
      fansCount().then(
        res => {
          that.fans_count = res.data;
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
